import { GlobalDataTab } from "./GlobalDataTab";
import { PageHeader } from "../components/PageHeader";
import { useDocumentTitle } from "../utils/useDocumentTitle";

export const GlobalDataRoute = () => {
  useDocumentTitle("Global data");
  return (
    <section>
      <PageHeader
        title="Global data"
        description="Reference material agents read across projects: Drive folders and files from one shared drive, plus Slack channels. Each reaches the projects whose tenant and landlord match its scope, or every project if it has none."
      />
      <GlobalDataTab />
    </section>
  );
};
